"use client";
import "./contact.scss";
import { TextAttr } from "@/core/blocks/attributes";
import { Heading, ModuleAttribute } from "@cms/module-api/client";

/** Contact section using the form attribute provided by the forms addon. */
export default function ContactBlock() {
  return (
    <section className="block-contact">
      <div className="container contact-grid">
        <div className="contact-intro">
          <Heading name="title" className="section-title" placeholder={{ nl: "Contact", en: "Contact" }} />
          <TextAttr name="text" rich as="div" placeholder={{ nl: "Hoe kunnen mensen je bereiken?", en: "How can people reach you?" }} />
        </div>
        <div className="contact-form">
          <ModuleAttribute type="form" name="form" />
        </div>
      </div>
    </section>
  );
}

export const meta = { label: "Contact form", icon: "mail" };

export function defaults(): Record<string, unknown> {
  return { title: { nl: "Contact" }, text: {} };
}
